import states from 'Data/states.json';

export interface IStateObject {
  Abbreviation: string;
  Name: string;
  Channels: string[];
}

interface ISetStateServer {
  redirect: string;
}

export function StateAbbrExists(selectedState: string, siteChannel: string): boolean {
  if (
    states.find(
      (state) =>
        state.Channels.find((channel) => channel.toLowerCase() === siteChannel.toLowerCase()) &&
        state.Abbreviation.toUpperCase() === selectedState.toUpperCase(),
    )
  ) {
    return true;
  }
  return false;
}

export function GetStateName(stateAbbr: string): string {
  var foundState: IStateObject[] = states.filter(
    (state) => state.Abbreviation.toUpperCase() === stateAbbr.toUpperCase(),
  );
  if (foundState != null && foundState.length > 0) {
    return foundState[0] !== null && foundState[0].Name !== null ? foundState[0].Name : '';
  }
  return '';
}

export function GetSiteStates(siteChannel: string | undefined): IStateObject[] {
  if (!siteChannel) return [];
  return states.filter((state) =>
    state.Channels.find((channel) => channel.toLowerCase() === siteChannel.toLowerCase()),
  );
}

export function GetSiteStatesAbbr(siteChannel: string | undefined): string[] {
  var siteStates = GetSiteStates(siteChannel);
  if (siteStates) {
    return siteStates.map((stateItem) => stateItem.Abbreviation);
  } else return [];
}

export async function SetUserSelectedState(selectedState: string): Promise<string> {
  try {
    const res = await fetch(`/api/sitecore/StateSpecific/SetAgentSelectedState`, {
      method: 'POST',
      body: new URLSearchParams({ currentUrl: window.location.href, state: selectedState.toUpperCase() }),
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: ISetStateServer = await res.json();
        return data.redirect;
      }
    }
  } catch {
    console.error('Error saving state for user');
    return '';
  }
  return '';
}
